import React from 'react';

import {
  EdgesContext,
  EdgesContextValue,
} from 'processes/graph-builder-processes/flowchart-viz/horizontal-flowchart/EdgesContext';
import {
  HandlesContext,
  HandlesContextValue,
} from 'processes/graph-builder-processes/flowchart-viz/horizontal-flowchart/HandlesContext';
import {
  NodesContext,
  NodesContextValue,
} from 'processes/graph-builder-processes/flowchart-viz/horizontal-flowchart/NodesContext';
import {
  getValueForPlatformFeaturesContext,
  PlatformFeaturesContext,
  PlatformFlowchartFeatures,
} from 'processes/graph-builder-processes/flowchart-viz/horizontal-flowchart/PlatformFeaturesContext';
import {FlowchartEditorMode} from 'processes/graph-builder-processes/flowchart-viz/horizontal-flowchart/ProcessFlowchartEditorModeConstants';

export interface CanvasContextProvidersProps {
  platformFeaturesContext: PlatformFlowchartFeatures;
  handlesContext: HandlesContextValue;
  nodesContext: NodesContextValue;
  edgesContext: EdgesContextValue;
  editorMode: FlowchartEditorMode;
  children: React.ReactNode;
}

/**
 * Wraps the canvas in context providers needed for rendering the flowchart.
 */
export function CanvasContextProviders({
  platformFeaturesContext,
  handlesContext,
  nodesContext,
  edgesContext,
  editorMode,
  children,
}: CanvasContextProvidersProps): JSX.Element {
  return (
    <PlatformFeaturesContext.Provider
      value={getValueForPlatformFeaturesContext(platformFeaturesContext, editorMode)}
    >
      <HandlesContext.Provider value={handlesContext}>
        <NodesContext.Provider value={nodesContext}>
          <EdgesContext.Provider value={edgesContext}>{children}</EdgesContext.Provider>
        </NodesContext.Provider>
      </HandlesContext.Provider>
    </PlatformFeaturesContext.Provider>
  );
}
